import { Navigate, createFileRoute } from '@tanstack/react-router';
import { MessageSquare } from 'lucide-react';
import { EmptyState, SkeletonRows } from '@/components/ui';
import { useChannels } from '@/features/chat/api';
import { useUi } from '@/stores/ui';

export const Route = createFileRoute('/w/$workspaceId/chat/')({ component: ChatIndex });

/** Opens the conversation the user was last in, or the first channel. */
function ChatIndex() {
  const { workspaceId } = Route.useParams();
  const channels = useChannels();
  const last = useUi((s) => s.activeViews[`chat:${workspaceId}`]);
  if (channels.isLoading) return <SkeletonRows className="p-4" />;
  const list = channels.data ?? [];
  const target = list.find((c) => c.id === last) ?? list.find((c) => c.type === 'public') ?? list[0];
  if (!target) {
    return (
      <EmptyState
        className="h-full"
        icon={<MessageSquare />}
        title="No conversations yet"
        description="Channels and direct messages you are part of show up here."
      />
    );
  }
  return <Navigate to="/w/$workspaceId/chat/$channelId" params={{ workspaceId, channelId: target.id }} replace />;
}
